import React, { useState } from "react";

import { motion, AnimatePresence } from "framer-motion";

import Footer from "./Footer";
import Navbar from "./Navbar";

const Support = () => {
  const faqItems = [
    {
      question:
        "How do I set up my Starlabs Technologies Home Security System?",
      answer:
        "Each system comes with a step-by-step guide in the box. For extra help, check our Installation Guide (#) online or contact us for a walkthrough-professional setup is also available in many regions. ",
    },
    {
      question: "What if my SAAS subscription isn’t working?",
      answer:
        "First, ensure your internet connection is stable. Then, log out and back in. If the issue persists, reach out via live chat or email with your account details-we’ll fix it fast. ",
    },
    {
      question: "Can I expand my IoT or NAS system later?",
      answer:
        "Absolutely! Our solutions are scalable-add devices or storage as needed. Contact us for compatibility advice or upgrade options. ",
    },
    {
      question: "How secure is my data with your solutions?",
      answer:
        "We use encryption meeting ISO 27001 standards and multi-factor authentication. Your data’s safety is our priority—email us for specifics on any product. ",
    },
    {
      question: "What’s your return or warranty policy?",
      answer:
        "Most products come with a 1-year warranty and a 30-day return window. Check your purchase confirmation or contact us at administrator@starlabs.co.in for details.",
    },
  ];
  const FAQItem = ({ question, answer }) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
      <div className="border-b border-gray-700 py-2">
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="w-full text-left text-gray-100 font-medium"
        >
          {question}
        </button>
        <AnimatePresence>
          {isOpen && (
            <motion.div
              initial={{ height: 0, opacity: 0 }}
              animate={{ height: "auto", opacity: 1 }}
              exit={{ height: 0, opacity: 0 }}
              transition={{ duration: 0.3 }}
              className="text-sm text-gray-300 mt-2 overflow-hidden"
            >
              {answer}
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    );
  };

  return (
    <div>
      <Navbar />
      <div className="min-h-screen  text-gray-100 py-20">
        <motion.div
          className="max-w-screen-2xl mx-auto rounded-lg shadow-xl overflow-hidden"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <div className="p-6 md:p-8">
            <motion.h1
              className="text-2xl md:text-2xl  font-semibold mb-6"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
            >
              We're Here to Help You Succeed
              <br />
              Welcome to Starlabs Technologies Support
            </motion.h1>
            <div className=" pr-4 ">
              <motion.div
                initial="hidden"
                animate="visible"
                className="space-y-6"
              >
                <motion.section className="text-sm">
                  <p className="text-gray-300 leading-relaxed">
                    At Starlabs Technologies, a startup dedicated to innovation
                    and excellence, we’re committed to ensuring you get the most
                    out of our solutions-whether it’s Home Security Systems,
                    SAAS, IoT devices, or any of our cutting-edge offerings. Our
                    Support Page is your go-to resource for answers, assistance,
                    and guidance, available whenever you need it, wherever you
                    are. Let’s get you back on track with fast, reliable help.
                  </p>
                </motion.section>
                <motion.section className="text-sm">
                  <p className="text-gray-300 leading-relaxed">
                    How Can We Assist You?
                    <br /> We offer multiple ways to connect with our support
                    team, tailored to your needs:
                  </p>
                </motion.section>

                <motion.section>
                  <h2 className="text-lg mb-1">1. Email Support</h2>

                  <ul className="list-disc pl-6 mt-1 text-sm text-gray-300 space-y-2">
                    <li>Reach us at: administrator@starlabs.co.in</li>
                    <li>
                      Response Time: Within 24 hours, often sooner-our team
                      works across time zones to assist you promptly.
                    </li>
                    <li>
                      Best for: Detailed inquiries, technical issues, or
                      feedback.
                    </li>
                  </ul>
                </motion.section>

                <motion.section>
                  <h2 className="text-lg mb-1">2. Self-Help Resources</h2>

                  <ul className="list-disc pl-6 mt-1 text-sm text-gray-300 space-y-2">
                    <li>
                      Browse our FAQs, guides, and troubleshooting tips below-no
                      wait time needed.
                    </li>
                    <li>Best for: DIY solutions and quick fixes.</li>
                  </ul>
                </motion.section>

                <motion.section>
                  <h2 className="text-lg mb-1">
                    Frequently Asked Questions (FAQs)
                  </h2>
                  <p className="text-gray-300 leading-relaxed mb-4">
                    Here are answers to some common questions we receive:
                  </p>
                  <div className="space-y-3">
                    {faqItems.map((faq, index) => (
                      <FAQItem
                        key={index}
                        question={faq.question}
                        answer={faq.answer}
                      />
                    ))}
                  </div>
                  <p className="text-gray-300 leading-relaxed mb-4 mt-4">
                    <b>Still have questions?</b> Reach out-we’re happy to clarify
                    anything!
                  </p>
                </motion.section>

                <motion.section>
                  <h2 className="text-lg mb-1">Troubleshooting Tips</h2>
                  <p className="text-gray-300 leading-relaxed">
                    Try these quick fixes before contacting us-they solve most
                    issues
                  </p>
                  <ul className="list-disc pl-6 mt-1 text-sm text-gray-300 space-y-3">
                    <li>
                      <b>Device Not Responding (IoT/Home Automation): </b>
                      Restart the device and check your Wi-Fi connection. Ensure
                      it’s within range of the hub-50 meters max for most
                      models.
                    </li>
                    <li>
                      <b> Software Glitches (SAAS/Industrial Solutions): </b>
                      Clear your browser cache or reinstall the app. Update to
                      the latest version via our Downloads (#) page
                    </li>
                    <li>
                      <b>Security Alerts (Home Security): </b> Verify sensor
                      placement-avoid direct sunlight or drafts. Test via the
                      app’s diagnostic tool.
                    </li>
                    <li>
                      <b>NAS Access Issues: </b> Confirm network settings (IP
                      address, firewall) and reboot the device. Check cables for
                      loose connections
                    </li>
                    <li>
                      <b>RFID Barrier Malfunction: </b> Ensure the tag is within
                      5 meters and unobstructed. Clean the reader lens gently
                      with a dry cloth.
                    </li>
                  </ul>
                  <p className="text-gray-300 leading-relaxed">
                    If these don’t work, we’re a click or call away-don’t
                    hesitate!
                  </p>
                </motion.section>

                <motion.section>
                  <h2 className="text-lg mb-1">Submit a Support Ticket</h2>
                  <p className="text-gray-300 leading-relaxed">
                    For detailed or ongoing issues, submit a ticket:
                  </p>
                  <ul className="list-disc pl-6 mt-1 text-sm text-gray-300 space-y-3">
                    <li>
                      <b> How: </b>Email administrator@starlabs.co.in with your
                      name, product, and a brief description-or use our Support
                      Form (#).
                    </li>
                    <li>
                      <b> What to Expect: </b>A ticket number within 1 hour and
                      a resolution plan within 24 hours. We’ll keep you updated
                      every step of the way.
                    </li>
                  </ul>
                </motion.section>

                <motion.section>
                  <h2 className="text-lg mb-1">Community Support</h2>
                  <p className="text-gray-300 leading-relaxed">
                    Join our growing community:
                  </p>
                  <ul className="list-disc pl-6 mt-1 text-sm text-gray-300 space-y-3">
                    <li>
                      <b>Forum: </b>Share tips and ask peers at Your Forum Link
                      (#)-our team moderates and jumps in too.
                    </li>
                    <li>
                      <b>Blog: </b>Check our Blog (#) for tutorials, updates,
                      and pro tips-written by our experts for you.
                    </li>
                  </ul>
                </motion.section>

                <motion.section>
                  <h2 className="text-lg mb-1">
                    Why Choose Starlabs Technologies Support?
                  </h2>
                  <p className="text-gray-300 leading-relaxed">
                    As a startup, we’re not just about products—we’re about
                    people
                  </p>
                  <ul className="list-disc pl-6 mt-1 text-sm text-gray-300 space-y-3">
                    <li>
                      <b>24/7 Availability: </b>Global support, anytime,
                      anywhere-95% of queries resolved on first contact, per
                      early feedback.
                    </li>
                    <li>
                      <b>Startup Agility: </b>Fast, flexible help-no long waits
                      or rigid scripts.
                    </li>
                    <li>
                      <b>Innovation-Driven: </b>We’re always improving-your
                      input shapes our next steps.
                    </li>
                    <li>
                      <b> Customer First: </b>Early clients rate us 4.8/5 for
                      responsiveness-we’re here to exceed expectations.
                    </li>
                  </ul>
                  <p className="text-gray-300 leading-relaxed">
                    We’re not a faceless corporation-we’re a team passionate
                    about your success
                  </p>
                </motion.section>

                <motion.section>
                  <h2 className="text-lg mb-1">Get in Touch Today</h2>
                  <p className="text-gray-300 leading-relaxed">
                    No issue is too big or small—whether it’s a quick question
                    or a complex fix, we’ve got your back. Contact us now and
                    let’s solve it together:
                  </p>
                  <ul className="list-disc pl-6 mt-1 text-sm text-gray-300 space-y-3">
                    <li>Email: administrator@starlabs.co.in</li>
                    <li>Live Chat: Click the icon below to start</li>
                  </ul>
                </motion.section>
                <motion.section>
                  <h2 className="text-lg mb-1">Your Success is Our Mission</h2>
                  <p className="text-gray-300 leading-relaxed">
                    At Starlabs Technologies, we believe great support is as
                    vital as great products. Stay connected, and let us help you
                    thrive
                  </p>
                </motion.section>
              </motion.div>
            </div>
          </div>
        </motion.div>
      </div>
      <Footer />
    </div>
  );
};

export default Support;
